import { MatrixClient } from 'matrix-js-sdk';

export async function fetchUsersByRoles(mx: MatrixClient, Role:string, project: string) {
    const {baseUrl} = mx;
    console.log(project);
    const response = await fetch(
        `${baseUrl}/_matrix/client/r0/users/by_user_type?user_type=${Role}&project=${project}`,
        {
            headers: {
                Authorization: `Bearer ${mx.getAccessToken()}`,
            },
        }
    );

    if (!response.ok) {
        throw new Error(`Failed to fetch ${Role} users: ${response.status}`);
    }

    const data = await response.json();
    return data.user_ids;
}

export async function fetchDefaultContacts(mx: MatrixClient, project: string) {
    const { baseUrl } = mx;
    const response = await fetch(
        `${baseUrl}/_matrix/client/r0/rooms/contact?project=${project}`,
        {
            headers: {
                Authorization: `Bearer ${mx.getAccessToken()}`,
            },
        }
    );

    if (!response.ok) {
        throw new Error(`Failed to fetch default contacts: ${response.status}`);
    }

    const data = await response.json();
    return data.contacts as { ProjectCode: string, UserId: string, UserName: string }[];
}
